import { privateRoutes } from "@auth/PrivateRoutes";
import { CollaboratorStatusPath } from "@common/lang/locale/MenueditPath";
import { getStatusText } from "@component/statusbadgestailwind/StatusBadge";
import { API_ROUTES, apiGet } from "@configure/apiConfig";
import { getRouteByStatusAndModule } from "@configure/previousTab";
import { formatString } from "@utils/dataformatter/Rawformatter";
import { matchRoutes } from "react-router-dom";

export async function validateAndRedirectStatus({ pathname, dealid, demandid }) {
  const NotEntry = { data: false, message: "method executed successfully" };
  const matchedRoutes = matchRoutes(privateRoutes, pathname);
  if (!matchedRoutes || !matchedRoutes[0]) {
    return '/';
  }

  // Find status entry
  const statusEntry = Object.entries(CollaboratorStatusPath).find(([_, value]) =>
    pathname.startsWith(value)
  );
  let projectStatus = "";

  if (!statusEntry || !dealid) return null;
  const statusResponse = await apiGet(API_ROUTES.GET_DEAL_COLLABORATORS, {
    type: "getDealStatus",
    dealid: demandid || dealid,
    module: statusEntry[0]
  });

  const rawStatus = statusResponse?.data?.data;

  if (!rawStatus || rawStatus === null) {
    return '/permission-denied';
  }

  projectStatus = formatString(getStatusText(rawStatus, "contain"), "-");
  const currentRoute = matchedRoutes[0];
  const routeParams = currentRoute.params || {};
  let { dealstatus, projectid, inapnum, module: ParamModule,demandid:Paramdemandid } = routeParams;

  let module = currentRoute.route.path.split('/')?.[1]
  if (module === ':module') {
    module = ParamModule
  }
  if (module === 'rm') {
    const path = currentRoute.route.path;
    if (path.includes('rm/demandpipeline')) {
      module += `/${currentRoute.route.path.split('/')?.[2]}/${currentRoute.route.path.split('/')?.[3]}`
    }
    else {
      module += `/${currentRoute.route.path.split('/')?.[2]}`
    }
  }

  if (projectStatus.toLowerCase() !== dealstatus?.toLowerCase()) {
    const updatedPath = currentRoute.route.path;
    const isInab = inapnum
    let newPath = getRouteByStatusAndModule({ status: rawStatus, module: module, projectType: projectid ? "client" : inapnum ? "inab" : "" })

    if (isInab) {
      newPath = newPath.replace(':inapnum', inapnum)
    } else if (projectid) {
      newPath = newPath.replace(':projectid', projectid)
      newPath = newPath.replace(':demandid', Paramdemandid)
      // newPath = newPath.replace(':actionType', ACTION_TYPES[actionType])
    }
    return newPath;
  }
  return null;
}